import React from 'react'
import { IDNameDescriptionDictionary } from '../models/Site'
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect'
import { RiderPackageServiceModel } from '../models/superbit-api-models';

interface IInsuraceAndCoversDetails {
    productionData: any,
    allBanks: any,
    offer: any,
    InsuranceTypes: IDNameDescriptionDictionary,
    PassedTypeOfInsurance: IDNameDescriptionDictionary,
    setStateData: (name: string, e: any) => void,
    setComment: (name: string, e: any) => void,
    renderValidationError: (name: string) => React.ReactNode,
    setAlertMessege: (e: any, navigate: string) => void,
}

const InsuraceAndCoversDetails: React.FC<IInsuraceAndCoversDetails> = ({
    productionData,
    allBanks,
    offer,
    InsuranceTypes,
    PassedTypeOfInsurance,
    setStateData,
    setComment,
    renderValidationError,
    setAlertMessege,
}) => {

    const [over, setOver] = React.useState(false);


    const fff = () => {
        return productionData != null ? productionData.InsuranceType : 5;
    }

    const setInsuranseData = (name: string, value: any) => {


        if (name === "InsuranceType") {
            setAlertMessege("לשינוי סוג ביטוח", 'simulator');
            return;
        }

        if (name === "passedTypeOfInsurance1") {
            setAlertMessege("לשינוי סוג ביטוח", 'simulator');
            return;
        }
        if (name === "passedTypeOfInsurance2") {
            setAlertMessege("לשינוי סוג ביטוח", 'simulator');
            return;
        }
        if (name === "passedTypeOfInsurance3") {
            setAlertMessege("לשינוי סוג ביטוח", 'simulator');
            return;
        }
        if (name === "sueNumber1") {
            setAlertMessege('לשינוי עבר ביטוחי בשנה האחרונה', 'simulator');
            return;
        }
        if (name === "sueNumber2") {
            setAlertMessege('לשינוי עבר ביטוחי לפני שנתיים', 'simulator');
            return;
        }
        if (name === "sueNumber3") {
            setAlertMessege('לשינוי עבר ביטוחי לפני 3 שנים', 'simulator');
            return;
        }
        if (name === "revocationsAmount") {
            setAlertMessege('לשינוי מספר השלילות', 'simulator');
            return;
        }
        if (name === "bodyClaimsAmount") {
            setAlertMessege('לשינוי מספר תביעות גוף', 'simulator');
            return;
        }

        setStateData(name, value);
    }

    return (
        <>
            <section>
                <div className="section-title">
                    פרטי שיעבוד
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                סוג ביטוח
                            </div>
                            <div className="value">
                                {InsuranceTypes ? (
                                    <IDNameDescriptionItemSelect OnChange={setInsuranseData} Id={"InsuranceType"}

                                        Options={InsuranceTypes} Value={productionData != null ? productionData.insuranceType : null} />

                                ) : ""}
                            </div>
                        </div>
                    </div>
                    {productionData != null && productionData.insuranceType != null && productionData.insuranceType != undefined && productionData.insuranceType == 0 ?
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    שיעבוד
                                </div>
                                <div className="value">

                                    <select
                                        id="isVehicleEnslaved"
                                        value={productionData && productionData.isVehicleEnslaved}
                                        onChange={(e) => setStateData("isVehicleEnslaved", e.target.value === 'true')}
                                    >
                                        <option value="true">כן</option>
                                        <option value="false">לא</option>
                                    </select>



                                </div>
                            </div>
                        </div> : ""}

                </div>
                <div className={productionData != null && productionData.isVehicleEnslaved != null && productionData.isVehicleEnslaved ? "parameter-row" : "hide"}>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                גוף משעבד
                            </div>
                            <div className="value">
                                <select id="involvedPartyType" value={productionData.involvedPartyType}
                                    onChange={(e) => setStateData("involvedPartyType", e.target.value)}>
                                    <option value="" >בחר</option>
                                    <option value="0" >בנק</option>
                                    <option value="1" >חברה</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    {productionData.involvedPartyType == "0" &&
                        <>
                            <div className={productionData != null && productionData.involvedPartyType == "0" ? "parameter-item" : "hide"}>
                                <div className="field">
                                    <div className="title">
                                        שם הבנק
                                    </div>
                                    <div className="value">
                                        <select id="involvedBank" value={productionData && productionData.involvedBank || ""}
                                            onChange={(e) => setStateData("involvedBank", e.target.value)}>
                                            <option value="">בחר</option>
                                            {allBanks.map((bank: any, index: number) => (
                                                <option key={index} value={bank.BankName}>
                                                    {bank.BankName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {/* make list for all branch of bank by using bankName the user choose before*/}

                            <div className={productionData.involvedBank != null && productionData.involvedBank ? "parameter-item" : "hide"}>
                                <div className="field">
                                    <div className="title">
                                        שם הסניף
                                    </div>
                                    <div className="value">
                                        <select id="involvedBankBranch" value={productionData && productionData.involvedBankBranch && productionData.involvedBankBranch.split(',')[0] || ""}
                                            onChange={(e) => setStateData("involvedBankBranch", e.target.value)}>
                                            <option value="">בחר</option>
                                            {allBanks.find((bank: any) => bank.BankName === productionData.involvedBank) !== undefined &&
                                                allBanks.find((bank: any) => bank.BankName === productionData.involvedBank).branchCode.map((item: any, index: number) => (

                                                    <option key={index} value={item.Branch_Code}>
                                                        {"סניף:" + item.Branch_Code + "-  כתובת:" + item.Branch_Address}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    {productionData.involvedPartyType == "1" &&
                        <>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        חברה
                                    </div>
                                    <div className="value">
                                        <input type="text"
                                            onChange={(e: any) => setInsuranseData("involvedName", e.target.value)} value={productionData != null ? productionData.involvedName : ""}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        כתובת
                                    </div>
                                    <div className="value">
                                        <input type="text"
                                        onChange={(e: any) => setInsuranseData("InvolvedAddress", e.target.value)} value={productionData != null ? productionData.involvedAddress : ""}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </section >

            {productionData.offer && productionData.offer.riders && productionData.offer.riders.length > 0 &&

                <section>
                    <div className="section-title">
                        פרטי הריידרים
                    </div>

                    {productionData.offer.riders.map((rider: any, index: number) => (
                        <>
                            <div className="parameter-row" key={index}>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            חבילה
                                        </div>
                                        <div className="value">
                                            {rider.riderPackage.name}
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item" style={{ minWidth: '120px', maxWidth: 120 }}>
                                    <div className="field">
                                        <div className="title">
                                            עלות
                                        </div>
                                        <div className="value">
                                            {rider.price + "₪"}
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item" style={{ maxWidth: '500px' }}>
                                    <div className="field">
                                        <div className="title">
                                            מה כולל
                                        </div>
                                        <div style={{ textAlign: 'start' }}>
                                            <div className='right-align message-text' dangerouslySetInnerHTML={{ __html: rider.riderPackage.comment }}></div>
                                            {/* {rider.riderPackage.comment} */}
                                        </div>
                                        {/* {rider.riderPackageServices !== null && rider.riderPackageServices.map((item: any, index: number) => <div style={{display: 'flex'}} key={index}>
                                    {item.riderServiceCompany && item.riderServiceCompany.riderService ? item.riderServiceCompany.riderService.title : ""} " - "
                                    {item.riderServiceCompany && item.riderServiceCompany.riderComapny ? item.riderServiceCompany.riderComapny.name : ""}
                                </div>)} */}
                                    </div>
                                </div>

                            </div>
                        </>
                    ))}
                </section>
            }


            <section>
                <div className="section-title">
                    עבר ביטוחי
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value grey-text">
                                שנה אחרונה
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value">
                                {PassedTypeOfInsurance ? (<IDNameDescriptionItemSelect OnChange={setInsuranseData} Id={"passedTypeOfInsurance1"} Options={PassedTypeOfInsurance} Value={productionData != null ? productionData.passedTypeOfInsurance1 : ""} />
                                ) : ""}
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value">
                                <input type="number" id="sueNumber1" onChange={(e: any) => setInsuranseData("sueNumber1", e.target.value)} value={productionData.sueNumber1 != null ? productionData.sueNumber1 : ""} />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>{renderValidationError("sueNumber1")}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value grey-text">
                                לפני שנתיים
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value">
                                {PassedTypeOfInsurance ? (<IDNameDescriptionItemSelect OnChange={setInsuranseData} Id={"passedTypeOfInsurance2"} Options={PassedTypeOfInsurance} Value={productionData != null ? productionData.passedTypeOfInsurance2 : null} />
                                ) : ""}
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value">
                                <input type="number" id="sueNumber1" onChange={(e: any) => setInsuranseData("sueNumber2", e.target.value)} value={productionData != null ? productionData.sueNumber2 : ""} />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>{renderValidationError("sueNumber2")}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value grey-text">
                                לפני 3 שנים
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value">
                                {PassedTypeOfInsurance ? (<IDNameDescriptionItemSelect OnChange={setInsuranseData} Id={"passedTypeOfInsurance3"} Options={PassedTypeOfInsurance} Value={productionData != null ? productionData.passedTypeOfInsurance3 : null} />
                                ) : ""}
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value">
                                <input type="number" id="sueNumber1" onChange={(e: any) => setInsuranseData("sueNumber3", e.target.value)} value={productionData != null ? productionData.sueNumber3 : ""} />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>{renderValidationError("sueNumber3")}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מספר שלילות
                            </div>
                            <div className="value">
                                <input type="number" onChange={(e: any) => setInsuranseData("revocationsAmount", e.target.value)} value={productionData != null ? productionData.revocationsAmount : ""} />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>{renderValidationError("revocationsAmount")}</div>
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מספר תביעות גוף
                            </div>
                            <div className="value">
                                <input type="number" onChange={(e: any) => setInsuranseData("bodyClaimsAmount", e.target.value)} value={productionData != null ? productionData.bodyClaimsAmount : ""} />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>{renderValidationError("bodyClaimsAmount")}</div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className='wapper-checkbox'>
                    <div className="cell-checkbox">
                        <div>
                            <input disabled={true} type="checkbox" checked={productionData.offer != null && productionData.offer.mainVehicle} />
                        </div>
                        <div>
                            משמש כרכב עיקרי
                        </div>
                    </div>

                    <div className="cell-checkbox">
                        <div>
                            <input disabled={true} type="checkbox" checked={productionData.offer != null && productionData.offer.autodirection} />
                        </div>
                        <div>
                            כינון אוטומטי
                        </div>
                    </div>

                    <div className="cell-checkbox">
                        <div>
                            <input disabled={true} type="checkbox" checked={productionData.offer != null && productionData.offer.driveInShabbat} />
                        </div>
                        <div>
                            הרכב נוסע בשבת
                        </div>
                    </div>

                    <div className="cell-checkbox">
                        <div>
                            <input disabled={true} type="checkbox" checked={productionData != null && productionData.newForOld} />
                        </div>
                        <div>
                            חדש תמורת ישן
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="parameter-row">
                    <div className="parameter-item wide">
                        <div className="field">
                            <div className="title">
                                הערות
                            </div>
                            <textarea className='textarea-value' rows={3} onChange={(e: any) => setComment("comment", e)} value={productionData.comment != null && productionData.comment.length > 0 ? productionData.comment : ""} />
                            <div style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'end',
                                paddingTop: '5px',
                                color: 'red'
                            }}>{renderValidationError("comment")}</div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default InsuraceAndCoversDetails